import { useCallback, useRef } from 'react';
import avo from 'analytics/avo';
import usePDPGalleryProductProperties from './usePDPGalleryProductProperties';

// Fires "PDP Gallery Interacted" (CON-8512). Pass one GALLERY_INTERACTION key;
// every other interaction property stays omitted.
const usePDPGalleryInteractedEvent = () => {
  const productProperties = usePDPGalleryProductProperties();

  // Read through a ref so the callback identity stays stable - it is handed to
  // effects and to DOM listeners that must not re-subscribe on every render
  const productPropertiesRef = useRef(productProperties);
  productPropertiesRef.current = productProperties;
  const trackGalleryInteracted = useCallback(interactionProperty => {
    const properties = productPropertiesRef.current;
    avo.pdpGalleryInteracted({
      category: properties.category,
      productFamily: properties.productFamily,
      name: properties.name,
      variant: properties.variant,
      sku: properties.sku,
      price: properties.price,
      fabricId: properties.fabricId,
      productId: properties.productId,
      [interactionProperty]: true
    });
  }, []);
  return {
    trackGalleryInteracted
  };
};
export default usePDPGalleryInteractedEvent;